module.exports = __webpack_public_path__ + "static/media/arrow-down.aa109021.svg";